module.exports = __webpack_public_path__ + "static/img/pattern.fb84b8d1.png";